<template>
  <div>
    <div class="px-2 text-white mb-4 xl:px-12">
      <span class="pr-1 pl-2 text-2xl font-medium inline-block xl:!pl-0">Bukmacher {{ galaName }}</span>
    </div>
    <div class="bookmaker-commentary-tab text-content xl:mx-12" v-html="bookmakerContent"></div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: 'Bookmaker',
  inject: ['WP'],
  props: ['galaId', 'galaName', 'bookmakerContent'],
  mixins: [utils_mixin],
  data() {
    return {
      content: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.bookmakerContent) {
        new Promise((resolve) => {
          this.mountComponents();
          resolve();
        }).then(() => {
          setTimeout(() => {
            const contentElement = this.$el.querySelector('.bookmaker-commentary-tab');
            if (contentElement) {
              const links = contentElement.querySelectorAll('a');
              const spanFather = contentElement.querySelector('#koszulka-ksw');
              const detailsBtn = spanFather.querySelectorAll('span');
              const btn = detailsBtn[detailsBtn.length - 1];
              btn.addEventListener('click', () => {
                this.countClicks('RELACJA ➝ BUKMACHER: Kliki we wszystko, co klikalne', 'martial_fights');
              });
              links.forEach(link => {
                link.dataset.countClick = 'RELACJA ➝ BUKMACHER: Kliki we wszystko, co klikalne';
                link.dataset.countClickCategory = 'martial_fights';
                link.classList.add('no-default-style', 'underline', 'text-[#66E97E]');
              });
            }
          }, 400);
        });
      } else {
        setTimeout(() => {
          this.mountComponents();
          this.$nextTick(() => {
            const contentElement = this.$el.querySelector('.bookmaker-commentary-tab');
            if (contentElement) {
              const links = contentElement.querySelectorAll('a');
              const spanFather = contentElement.querySelector('#koszulka-ksw');
              const detailsBtn = spanFather.querySelectorAll('span');
              const btn = detailsBtn[detailsBtn.length - 1];
              btn.addEventListener('click', () => {
                this.countClicks('RELACJA ➝ BUKMACHER: Kliki we wszystko, co klikalne', 'martial_fights');
              });
              links.forEach(link => {
                link.dataset.countClick = 'RELACJA ➝ BUKMACHER: Kliki we wszystko, co klikalne';
                link.dataset.countClickCategory = 'martial_fights';
                link.classList.add('no-default-style', 'underline', 'text-[#66E97E]');
              });
            }
          });
        }, 3000);
      }
    });
  }
};
</script>